import { Center, Loader } from '@mantine/core';
import { useAuth } from './AuthProvider';
import LoginPage from '../../pages/LoginPage';

export const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const { session } = useAuth();

  if (!session) {
    return <LoginPage />;
  }

  return <>{children}</>;
};